import { usePresaleCountdown, pad } from "../lib/presale";

// Wspólny licznik końca ceny Early Bird / okna kodu zniżkowego.
// variant="inline"  - jedna linia tekstu (paski, małe miejsca)
// variant="blocks"  - kafelki dni/godz/min/sek (hero, pakiety)
// target="deadline" (domyślnie) - odlicza do końca Early Bird
// target="promo"    - odlicza do końca okna kodu zniżkowego
export const Countdown = ({ variant = "inline", className = "", target = "deadline" }) => {
    const state = usePresaleCountdown();
    const { ended, days, hours, minutes, seconds } =
        target === "promo" ? state.promoTime : state;

    if (ended) {
        return (
            <span
                data-testid="presale-countdown-ended"
                className={`font-bold uppercase tracking-[0.12em] whitespace-nowrap ${className}`}
            >
                {target === "promo" ? "Kod wygasł" : "Early Bird zakończony"}
            </span>
        );
    }

    if (variant === "blocks") {
        const cells = [
            { v: days, l: "dni" },
            { v: hours, l: "godz" },
            { v: minutes, l: "min" },
            { v: seconds, l: "sek" },
        ];
        return (
            <div
                data-testid="presale-countdown"
                role="timer"
                aria-label="Czas do końca promocji"
                className={`flex items-center gap-1.5 sm:gap-2 ${className}`}
            >
                {cells.map((c) => (
                    <span
                        key={c.l}
                        className="flex flex-col items-center rounded-lg bg-white/15 px-2 py-1.5 sm:px-3 sm:py-2 min-w-[48px] sm:min-w-[58px]"
                    >
                        <span className="font-display font-extrabold text-xl sm:text-2xl leading-none tabular-nums">
                            {pad(c.v)}
                        </span>
                        <span className="text-[9px] uppercase tracking-[0.18em] font-bold opacity-80 mt-1">
                            {c.l}
                        </span>
                    </span>
                ))}
            </div>
        );
    }

    return (
        <span
            data-testid="presale-countdown"
            role="timer"
            className={`font-bold tabular-nums whitespace-nowrap ${className}`}
        >
            {days > 0 && `${days} ${days === 1 ? "dzień" : "dni"} `}
            {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
    );
};
